import { render, staticRenderFns } from "./AreaEventHistoryPopout.vue?vue&type=template&id=5488fd76&scoped=true"
import script from "./AreaEventHistoryPopout.vue?vue&type=script&lang=ts"
export * from "./AreaEventHistoryPopout.vue?vue&type=script&lang=ts"
import style0 from "./AreaEventHistoryPopout.vue?vue&type=style&index=0&id=5488fd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488fd76",
  null
  
)

export default component.exports